import { get, ENDPOINTS } from "../../../services/shopify";
import { logger } from "../../../core";
import { ERROR_TYPE } from "../../../core/constants";

export const rejectSession = async (token, sessionID, gatewayName) => {
  try {
    if (!token || !sessionID || !gatewayName) {
      throw new Error("token, sessionID and gateway name are mandatory");
    }

    const response = await get({
      endpoint: ENDPOINTS.REJECT,
      token: token,
      query: `${gatewayName}/${sessionID}`,
    });

    return response?.data;
  } catch (err) {
    logger.error(`rejectSession(): ${err}`);
    
    return (
      err.response.data ?? {
        errorCode: ERROR_TYPE.INVALID_REQUEST,
      }
    );
  }
};
